var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalHeader',{attrs:{"handleClose":_vm.handleClose,"headerText":"Please add payment information to continue using JumpCloud","showClose":true}}),_c('PaymentsWrapper',{attrs:{"location":_vm.$options.modalLocation},on:{"cancelled":_vm.handleClose,"error":_vm.handleError,"success":_vm.handleNextStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }